/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toCompanyProps } from './translator/company'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { SelectableCompany, FetchCompany, GetCompany } from '@/infrastructure/network/Monitaro/requests/company'

export default class Company extends MonitaroGatewayBase {
  async SelectableCompany(query?: IQueryProps) {
    const response = await this.apiClient.request(new SelectableCompany(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.companies.map((prop) => toCompanyProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchCompany(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchCompany(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.companies.map((prop) => toCompanyProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetCompany(id: string) {
    const { company } = await this.apiClient.request(new GetCompany(id))
    return toCompanyProps(company)
  }
}
